// components/utils/AttachedFileChip.tsx
import { FC } from "react";
import { Chip, Tooltip } from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import DescriptionIcon from "@mui/icons-material/Description";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import ImageIcon from "@mui/icons-material/Image";
import AudiotrackIcon from "@mui/icons-material/Audiotrack";
import MovieIcon from "@mui/icons-material/Movie";
import TableChartIcon from "@mui/icons-material/TableChart";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import { IDocumento } from "./FileUpload";

type Props = {
  documento: IDocumento;
  onRemove: () => void;
};

const toMB = (bytes: number) => Math.round((bytes / (1024 * 1024)) * 100) / 100;

function getIconByType(doc: IDocumento) {
  const t = (doc.type || "").toLowerCase();
  const ext = (doc.extension || "").toLowerCase();

  if (t.includes("pdf") || ext === "pdf") return <PictureAsPdfIcon />;
  if (t.startsWith("image/")) return <ImageIcon />;
  if (t.startsWith("audio/")) return <AudiotrackIcon />;
  if (t.startsWith("video/")) return <MovieIcon />;

  if (
    ext === "csv" ||
    ext === "xls" ||
    ext === "xlsx" ||
    t.includes("spreadsheet")
  )
    return <TableChartIcon />;

  if (
    ext === "doc" ||
    ext === "docx" ||
    ext === "ppt" ||
    ext === "pptx" ||
    t.includes("msword") ||
    t.includes("presentation") ||
    t.includes("officedocument")
  )
    return <DescriptionIcon />;

  return <InsertDriveFileIcon />;
}

const AttachedFileChip: FC<Props> = ({ documento, onRemove }) => {
  const label = `${documento.name} (${toMB(documento.size)} MB)`;

  return (
    <Tooltip title={label}>
      <Chip
        icon={getIconByType(documento)}
        label={label}
        onDelete={onRemove}
        deleteIcon={<DeleteOutlineIcon />}
        variant="outlined"
        sx={{
          maxWidth: { xs: "60%", sm: "50%", md: "40%" },
          ".MuiChip-label": {
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          },
          borderRadius: 2,
        }}
      />
    </Tooltip>
  );
};

export default AttachedFileChip;
